import axios from "axios";
import { getDomain } from "../../../../../Utilities/utils";
import { PINCODE_API_ENDPOINT } from "../../../../../PersonalAccident/apiConfig";
import axiosInstance from "../../../../../Utilities/djangoAxiosInstance";

export default async function handleRelianceInputChangeHelper(
  event,
  setOptions,
  setLoading,
  formik,
  name
) {
  const { value } = event?.target ?? {};
  if (
    name === "nomineeDetails.NomineeAddress.Pincode" ||
    name === "proposerDetails.CommunicationAddress.Pincode" ||
    name === "proposerDetails.PermanentAddress.Pincode"
  ) {
    if (!value || value.length !== 6 || !Number.isInteger(Number(value))) {
      setOptions([]);
      return;
    }
    setLoading(true);
    const domain = getDomain();

    try {
      // Call pincode api
      const response = await axiosInstance.get(
        `${PINCODE_API_ENDPOINT}/${value}`
      );
      console.log("pincod api data", response.data);
      setOptions(response.data);
      setLoading(false);
    } catch (error) {
      setOptions([]);
      setLoading(false);
    }
  }
}
